module.exports = __webpack_public_path__ + "static/media/mausam - ground froast.70b4950a.png";